export default __webpack_public_path__ + "static/media/logo-white.700fab9b.png";